<template>
    <div class="page_">
        <div v-if="flag" class="text_">
          来自保思平台用户{{params.name}}的邀请：<br /><br />
          Hi 朋友<br />
          保思是集交易、工具、团队管理于一体的保险平台，来跟我一起使用保思平台吧。<br />
          您的登录账号是{{params.userName}}，初始密码是{{params.pwd}}。<br />
          请点击【同意】，确认接受开通您的账号。<br /><br />
          注：链接将在3天后失效，届时系统将自动视为您放弃本次邀请，请尽快确认。
          <cube-button style="width: 100px; margin: 30px auto;" @click="activeUser">同意</cube-button>
        </div>

        <div v-else>
          <img class="img_" src="../../../assets/image/nsale/error.png" alt="" v-if="type === 'error'">
          <img class="img_" src="../../../assets/image/nsale/correct.png" alt="" v-if="type === 'correct'">
          {{this.message}}
        </div>
    </div>
</template>
<style lang="scss" scoped>
.page_ {
  .text_ {
    font-size: 14px;
    text-align: left;
    line-height: 25px;
  }
  margin-top: 100px;
   p {
       padding: 0;
       margin: 0;
   }
   .img_ {
     width: 25px;
     height: 25px;
     vertical-align: middle;
   }
}
</style>
<script>
import api from '@/utils/api'
export default {
    data () {
      return {
        flag: '',
        type: '',
        query: {},
        message: '',
        params: {},
      }
    },
    mounted() {
      this.query = this.$route.query
      // 确认链接
      this.inviterUser()
    },
    methods: {
      inviterUser() {
        let param = this.query.param
        api.inviterUser(param).then(res => {
          if (res.data.returnCode !== '0000') {
            this.type = 'error'
            this.message = res.data.returnMsg
            this.flag = false
          } else {
            this.flag = true
            this.params = res.data.data
          }
        })
      },
      activeUser() {
        let param = this.query.param
        api.activeUser(param).then(res => {
          if (res.data.returnCode != '0000') {
            this.type = 'error',
            this.message = res.data.returnMsg
          }
          this.flag = false
          this.type = 'correct'
          this.message = '账号已开通成功'
        })
      }
    }
}
</script>
